import compact from "lodash/compact";
import { FetchLatestFiltersParams } from "PFCore/services/filters";
import { PageTarget } from "PFTypes/saved_filters";

export const savedFiltersKeys = {
  all: () => ["savedFilters"],
  target: (target: PageTarget) => [...savedFiltersKeys.all(), target],
  removal: () => [...savedFiltersKeys.all(), "remove"],
  creation: () => [...savedFiltersKeys.all(), "create"],
  latestFilters: (params?: FetchLatestFiltersParams) =>
    compact(["latestFilters", params?.target, params?.key])
};
